(function() {

  class ArticleSlider {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');
      
      this.element = element;
      this.itemsCount = element.querySelectorAll('.u-article-slider__item').length;
      this.hasArrows = this.itemsCount > 3 && !this.element.closest('.u-article-slider__wrapper').classList.contains('u-article-slider--style-desktop-grid');
      this.isGridOnMobile = !!this.element.closest('.u-article-slider--style-mobile-grid');
      this.isGridOnDesktop = !!this.element.closest('.u-article-slider--style-desktop-grid');
      this.init();

      var event = new CustomEvent('generate-smooth-scroll-links', { detail: element });
      document.dispatchEvent(event);
    }

    init() {

      var settings = {
        autoWidth: true,
        arrows: this.hasArrows,
        pagination: '.u-pagination',
        type: 'loop'
      };

      if(this.isGridOnDesktop) {
        settings.destroy = true;
        settings.breakpoints = {
          1183: {
            destroy: false
          },
        };
      }

      if(this.isGridOnMobile) {
        var breakpoint = settings.breakpoints || {};
        breakpoint[1183] = {
          destroy: true
        };
        settings.breakpoints = breakpoint;
      }

      console.log('settings', settings);
      this.splide = new Splide(this.element, settings)
      
      this.splide.on('mounted', () => {
        console.log('#mouted')
        this.refreshSliderArrows();
        this.refreshSliderPagination();
      });
      this.splide.on('move', () => {
        this.element.classList.add('u-animation--disabled');
      });

      this.splide.on('pagination:mounted', () => {
        console.log('pagination:mounted');
        this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination').appendChild(this.splide.Components.Pagination.data.list);
      });

      this.splide.on('pagination:updated', () => {
        console.log(this.splide.Components.Pagination.data.list);
        this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination').appendChild(this.splide.Components.Pagination.data.list);
      });
      this.splide.on('destroy', () => {
        this.onDestory();
      });
      this.splide.on('remount', () => {
        this.onRemount();
      });

      window.addEventListener('resize', () => {
        this.refreshSliderArrows();
        this.refreshSliderPagination();
      });

      this.splide.mount();
    }

    refreshSliderArrows() {
      setTimeout(() => {
        if (this.hasArrows && this.splide.Components.Arrows) {
          const arrowsContainer = this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__arrows');
          arrowsContainer.appendChild(this.splide.Components.Arrows.arrows.next);
          arrowsContainer.appendChild(this.splide.Components.Arrows.arrows.prev);
        }
      });
    }

    refreshSliderPagination() {
      const pagination = this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination');

      setTimeout(() => {
        if (this.splide.Components.Pagination.data.list) {
          pagination.appendChild(this.splide.Components.Pagination.data.list);
        }
      });
      // this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination').appendChild(this.splide.Components.Pagination.data.list);

      let elements = [].slice.call(this.element.querySelectorAll('.splide__slide[id]'), 0);

      let trackWidth = elements.map(function(item) { return item.clientWidth }).reduce(function(a,b){
        return a + b
      }, 0);

      // + 2px for rendering bug
      if ( this.element.querySelector('.splide__track').clientWidth + 2 >= trackWidth) {
        this.splide.options = { drag: false };
        this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination').classList.remove('is-visible')
      } else {
        this.splide.options = { drag: true };
        this.element.closest('.u-article-slider__wrapper').querySelector('.u-article-slider__pagination').classList.add('is-visible')
      }
    }

    onRemount() {
      console.log('#onRemount');
      list.querySelectorAll('.u-article-slider__spacer').forEach((s) => s.remove());
    }

    spacerAnimation(spacer, lineNumber) {
      let tl = gsap.timeline({
        onStart: self => {
          console.log('start animation spacer');
          spacer.classList.add('u-animation--is-running')
        },
        onComplete: self => {
          console.log('end animation spacer');
          spacer.classList.remove('u-animation--is-running')
          spacer.classList.add('u-animation--is-completed')
        },
      });

      const duration = .8;
      const delay = .8 * (lineNumber + 0.5);

      // add animations and labels to the timeline
      tl.addLabel("start")

      tl.fromTo(
        spacer, 
        {opacity: '0'}, 
        {opacity: '1', delay: delay, duration: duration,}
      )
      tl.addLabel("end");
    }

    onDestory() {
      if(this.isGridOnDesktop && window.innerWidth > 1183) {
        const list = this.element.querySelector('.splide__list');
        list.querySelectorAll('.u-article-slider__spacer').forEach((s) => s.remove());

        const spacer = document.createElement('span');
        spacer.classList.add('u-article-slider__spacer');
        spacer.classList.add('u-article-slider__spacer--first');
        list.insertBefore(spacer, list.firstChild);
        this.spacerAnimation(spacer, 0);

        list.querySelectorAll('.splide__slide:nth-child(3n + 4)').forEach((item, i) => {
          const spacer = document.createElement('span');
          spacer.classList.add('u-article-slider__spacer');
          list.insertBefore(spacer, item.nextSibling);
          this.spacerAnimation(spacer, i + 1);
        })
      } else if(!this.isGridOnDesktop && window.innerWidth > 1183) {
        const list = this.element.querySelector('.splide__list');
        list.querySelectorAll('.u-article-slider__spacer').forEach((s) => s.remove());
        list.querySelectorAll('.splide__slide:nth-child(3n + 3)').forEach((item, i) => {
          const spacer = document.createElement('span');
          spacer.classList.add('u-article-slider__spacer');
          list.insertBefore(spacer, item.nextSibling);
          this.spacerAnimation(spacer, i + 1);
        })
      } else if(this.isGridOnMobile && window.innerWidth <= 1183) {
        const list = this.element.querySelector('.splide__list');
        list.querySelectorAll('.u-article-slider__spacer').forEach((s) => s.remove());

        const spacer = document.createElement('span');
        spacer.classList.add('u-article-slider__spacer');
        spacer.classList.add('u-article-slider__spacer--first');
        list.insertBefore(spacer, list.firstChild);
        this.spacerAnimation(spacer, 0);

        list.querySelectorAll('.splide__slide').forEach((item, i) => {
          const spacer = document.createElement('span');
          spacer.classList.add('u-article-slider__spacer');
          list.insertBefore(spacer, item.nextSibling);
          this.spacerAnimation(spacer, i + 1);
        })
      }
      
      this.splide.on('remount', () => {
        this.onRemount();
      });

    }
  }
  
  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-article-slider .splide');

    for (const element of elements) {
      new ArticleSlider(element)
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });
  
  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();